@if (data && hasPermission(Permissions.ViewDashboards)) {
  <div class="mt-5 w-full">
    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      @for (card of cards; track $index) {
        <app-dashboard-item
          [iconSvg]="card.iconSvg"
          [title]="card.title"
          [mainValue]="card.mainValue"
          [chartData]="card.chartData"
          [entityName]="card.entityName"
          [isEmpty]="card.isEmpty ?? false"
          [clickable]="card.clickable ?? false"
          (cardClick)="card.action?.()"/>
      }
    </div>
  </div>
}
